import type { NormalizeOAS, OASOutput } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type ResponseBody = OASOutput<O, '/api/templates', 'get'>;

type Template = {
  name: string;
  guid: string;
  internalCategory: string | null;
  thumbnailUrl: string | null;
};

type Result = Template[];

export const listTemplatesFactory = (apiClient: ApiClient) => {
  const listTemplates = async () => {
    const response = await apiClient['/api/templates'].get();
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return response.map((template) => ({
      name: template.name,
      guid: template.guid,
      internalCategory: template.internalCategory ?? null,
      thumbnailUrl: template.thumbnailUrl ?? null,
    }));
  };

  return listTemplates;
};
